import { render, staticRenderFns } from "./ProfilePopup.vue?vue&type=template&id=dba0efb2&scoped=true"
import script from "./ProfilePopup.vue?vue&type=script&lang=js"
export * from "./ProfilePopup.vue?vue&type=script&lang=js"
import style0 from "./ProfilePopup.vue?vue&type=style&index=0&id=dba0efb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba0efb2",
  null
  
)

export default component.exports